import React, { useEffect, useState } from "react";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import Loader from "../../../components/loader/loader";
import CustomTable from "../../../components/table/table";
import {
  admin_eventbooking_list,
  admin_eventbooking_delete,
} from "../admin.api";
import ManageBook from "./booking/manage";
import "./view.css";
import jwtDecode from "jwt-decode";
import * as XLSX from "xlsx";
import TextField from "../../../components/inputs/textfield";
import SearchButton from "../../../components/buttons/search/search-btn";

export default function View(props) {
  const [data, setdata] = useState([]);
  const [addNew, setAddNew] = useState(false);
  const [addNewOpen, setAddNewOpen] = useState(false);
  const [activeOnly, setActiveOnly] = useState(true);

  const [formData, setFormData] = useState({});
  const [isActive, setIsActive] = useState(true);
  const [edit, setEdit] = useState(false);
  const [view, setView] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [statusFilter, setStatusFilter] = useState("");
  const [search, setSearch] = useState("");
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [suggestionsDisplay, setSuggestionsDisplay] = useState(false);
  const [displaySuggestions, setDisplaySuggestions] = useState([]);

  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const handleEventList = (
    statusFilterParam = statusFilter,
    searchParam = search,
    activeOnlyParam = activeOnly
  ) => {
    setIsActive(true);
    admin_eventbooking_list(statusFilterParam, searchParam, activeOnlyParam)
      .then((res) => {
        let tempData = res?.data;
        tempData?.forEach((item, index) => {
          item["slno"] = index + 1;
        });
        setdata(tempData);
        const seen = new Set();
        const newData = tempData.filter((item) => {
          if (!seen.has(item.event_name_en)) {
            seen.add(item.event_name_en);
            return true;
          }
          return false;
        });
        setSearchSuggestions(newData);
        setDisplaySuggestions(newData);
        setIsActive(false);
      })
      .catch((error) => {
        console.error("Error fetching event bookings:", error);
        setIsActive(false);
      });
  };
  useEffect(() => {
    handleEventList(statusFilter, search, activeOnly);
  }, [activeOnly]); 

  useEffect(() => {
    handleEventList(statusFilter, search, activeOnly);
  }, []);

  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value;
    console.log(e.target.value, "handle change");
    setStatusFilter(selectedStatus);
  };

  const handleClose = () => {
    setAddNew(false);
    setEdit(false);
    setFormData({});
    handleEventList();
  };

  const handleView = (data) => {
    let path = `/event-booking/${data.uuid}`;
    props.history.push(path);
  };

  const handleEdit = (data) => {
    setAddNew(true);
    setFormData(data);
    setView(true);
  };
  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    admin_eventbooking_delete(data.uuid)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        handleEventList();
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleEventList();
    }
  };
  const downloadCSV = () => {
    const headers = [
      "Sl. No.",
      "Participant Name",
      "Contact Number",
      "Email ID",
      "Address",
      "Desugnation",
      "Registration Type",
      "Number of Days",
      "Booking Date",
      "Amount",
      "Registration Reference ID",
      "Payment Confirmation",
      "Registration Status",
      "Event Name",
      "Event Date",
      "Organized By",
      // "Reference Number",
      // // "Booking Status",
      // "Bookinh Ref Id",
      // "Registration Type"
    ];

    const rows = data.map((item, index) => [
      index + 1,
      item.full_name,
      item.contact_no,
      item.email,
      item?.address,
      item?.designation,
      item.registration_type,
      item.days,
      item?.event_booking_date,
      item.fees,
      item.booking_ref_id,
      item.payment_status === 0
        ? "Pending"
        : item.payment_status === 1
        ? "Paid"
        : item.payment_status,
      item.booking_status_text,
      item?.event_name_en,
      item?.event_date,
      item?.oraganized_by_en,
      // item?.reference_no,
      // // item?.booking_status_text,
      // item?.booking_ref_id,
      // item?.registration_type
    ]);

    const worksheetData = [headers, ...rows];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Participants");

    XLSX.writeFile(workbook, "event_participants.xlsx");
  };
  const handleSearch = () => {
    handleEventList(statusFilter, search, activeOnly);
  };
  const handleClear = () => {
    setSearch("");
    setStatusFilter("");
    setIsActive(true);
    setActiveOnly(true); 
    setTimeout(() => {
      handleEventList();
    }, 1000);
  };
  useEffect(() => {
    if (search) {
      const filteredSuggestions = searchSuggestions.filter((item) =>
        item.event_name_en.toLowerCase().includes(search.toLowerCase())
      );
      setDisplaySuggestions(filteredSuggestions);
    } else if (search == "") {
      const seen = new Set();
      const newData = data.filter((item) => {
        if (!seen.has(item.event_name_en)) {
          seen.add(item.event_name_en);
          return true;
        }
        return false;
      });
      setDisplaySuggestions(newData);
    }
  }, [search]);

  return (
    <div>
      <Loader open={isActive} />
      <div className="view-container">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h6>
            <b>Event Registrations</b>
          </h6>
          <button
            className="px-2 py-2 search-style border-0 text-white rounded"
            onClick={downloadCSV}
          >
            Download Excel
          </button>
        </div>
        <hr />
        <div className="d-flex justify-content-start ">
          <div className="d-flex ">
            <div
              className=" ml-2 mr-2 col-6"
              onClick={(e) => {
                setSuggestionsDisplay(!suggestionsDisplay);
                console.log("clicked field");
              }}
            >
              <TextField
                id="outlined-basic"
                name="search"
                variant="outlined"
                placeholder="Search Name"
                value={search ?? "Search"}
                onChange={(e) => setSearch(e.target.value)}
              />
              {displaySuggestions && suggestionsDisplay && (
                <div className="searchSuggestions border w-100">
                  {displaySuggestions?.map((item, i) => (
                    <div
                      className="py-2 border-bottom search-item"
                      onClick={(e) => {
                        setSearch(item?.event_name_en);
                        setSuggestionsDisplay(false);
                        setDisplaySuggestions([]);
                      }}
                    >
                      {item?.event_name_en}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="col-6 mb-3 mr-2">
              <select
                className="form-select"
                value={statusFilter ?? ""}
                onChange={(e) => handleStatusChange(e)}
              >
                <option value={""}>Select Registration Status</option>
                <option value={0}>Payment Pending</option>
                <option value={1}>Payment Done</option>
                {/* <option value={2}>Payment Approved</option> */}
                <option value={4}>Approved</option>
              </select>
            </div>
            <div className=" d-flex">
              <SearchButton
                {...props}
                onClick={() => (search || statusFilter) && handleSearch()}
              />
              <div className="mx-2">
                <div className="clearSearch" onClick={() => handleClear()}>
                  Clear Search
                </div>
              </div>
              <div className="mx-2">
                <div className="clearSearch">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={activeOnly}
                      onChange={() => {
                        setActiveOnly(!activeOnly);
                      }}
                    />
                    Active
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ---------admin-------------- */}
        {adminType === 1 && (
          <CustomTable
            {...props}
            columns={[
              { title: "No", field: "slno" },
              { title: "Event Name", field: "event_name_en" },
              { title: "User Name", field: "full_name" },
              { title: "Address", field: "address" },
              { title: "Event Date", field: "event_date" },
              { title: "Registration Reference ID", field: "booking_ref_id" },
              {
                title: "Payment Confirmation",
                field: "payment_status",
                type: "payment status",
              },

              {
                title: "Registration Status",
                field: "booking_status",
                type: "bookingStatus",
              },
            ]}
            data={data}
            actions={[
              { type: "view", handleClick: handleView },
              // { type: "edit", handleClick: handleEdit },
              // { type: "delete", handleClick: handleDelete },
            ]}
          />
        )}
        {/* ---------inter-admin-------------- */}
        {adminType === 3 && (
          <CustomTable
            {...props}
            columns={[
              { title: "No", field: "slno" },
              { title: "Event Name", field: "event_name_en" },
              { title: "User Name", field: "full_name" },
              { title: "Address", field: "address" },
              { title: "Event Date", field: "event_date" },
              { title: "Registration Reference ID", field: "booking_ref_id" },
              {
                title: "Registration Status",
                field: "booking_status",
                type: "bookingStatus",
              },
            ]}
            data={data}
            actions={[
              { type: "view", handleClick: handleView },
              // { type: "edit", handleClick: handleEdit },
              { type: "delete", handleClick: handleDelete },
            ]}
          />
        )}
        {/* ---------super-admin-------------- */}
        {adminType === 2 && (
          <CustomTable
            {...props}
            columns={[
              { title: "No", field: "slno" },
              { title: "Event Name", field: "event_name_en" },
              { title: "User Name", field: "full_name" },
              { title: "Address", field: "address" },
              { title: "Event Date", field: "event_date" },
              { title: "Registration Reference ID", field: "booking_ref_id" },
              {
                title: "Payment Confirmation",
                field: "payment_status",
                type: "payment status",
              },
              {
                title: "Registration Status",
                field: "booking_status",
                type: "bookingStatus",
              },
            ]}
            data={data}
            actions={[
              { type: "view", handleClick: handleView },
              // { type: "edit", handleClick: handleEdit },
              { type: "delete", handleClick: handleDelete },
            ]}
          />
        )}
        {adminType === 23 && (
          <CustomTable
            {...props}
            columns={[
              { title: "No", field: "slno" },
              { title: "Event Name", field: "event_name_en" },
              { title: "User Name", field: "full_name" },
              { title: "Address", field: "address" },
              { title: "Event Date", field: "event_date" },
              { title: "Registration Reference ID", field: "booking_ref_id" },
              {
                title: "Payment Confirmation",
                field: "payment_status",
                type: "payment status",
              },
              {
                title: "Registration Status",
                field: "booking_status",
                type: "bookingStatus",
              },
            ]}
            data={data}
            actionsCondition={(row) => {
              return row?.booking_status_text !== "Approved"
                ? [
                    { type: "view", handleClick: () => handleView(row) },
                    { type: "edit", handleClick: () => handleEdit(row) },
                  ]
                : [{ type: "view", handleClick: () => handleView(row) }];
            }}
          />
        )}
      </div>
      {addNew && (
        <ManageBook
          open={addNew}
          adminType={adminType}
          edit={edit}
          view={view}
          handleClose={handleClose}
          formData={formData}
          data={data}
          addNewOpen={addNewOpen}
        />
      )}
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Registration ?"
          data={activeData}
          message="Are you sure to delete this Event Registration?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
